import { createAction } from 'redux-actions';

export const otpCodeRequest = createAction('USER_REGISTRATION_OTP_CODE_REQUEST');
export const otpCodeVerify = createAction('USER_REGISTRATION_OTP_CODE_VERIFY');
export const otpCodeVerifyError = createAction('USER_REGISTRATION_OTP_CODE_VERIFY_ERROR');
